// src/routes/ProtectedRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';

import { logout } from '../redux/slice/userSlice';
interface ModuleRight {
  right_view: 'Y' | 'N';
  module_url: string;
}

const ProtectedRoute = () => {
  // const dispatch = useDispatch();
  // dispatch(logout());
  const isAuthenticated = useSelector((state: any) => state.user.isAuthenticated); // Adjust if needed
  const modules: ModuleRight[] = useSelector((state: any) => state.user?.modules || []);
  const location = useLocation();
  const currentPath = location.pathname.replace(/^\/+/, '').split('/')[0];
  console.log("currentPath",currentPath)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  const permission = modules.find((item) => item.module_url === currentPath);
  console.log(currentPath);
  // console.log(permission);
  // console.log("currentPath",currentPath);
  // console.log("permission",permission);
  // console.log("modules",modules);
  // ✅ Allow access only if right_view === 'Y'

  if ((!permission || permission.right_view !== 'Y') && currentPath !== 'change-password' && currentPath !== 'profile' ) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
